import { Column } from "@/components/Column";

import { playyardSky } from "@/lib/playyardSky";

const BLADE_COUNT = 34;

const BLADES = Array.from({ length: BLADE_COUNT }, (_, index) => {
  const widthCqw = 2.4 + playyardSky.random(index + 601) * 2;
  return {
    left: index * (100 / (BLADE_COUNT - 2)) - 2,
    widthCqw,
    delayS: -playyardSky.random(index + 701) * 3,
  };
});

// Tall blades along the bottom edge that tuck in front of the nearest pets.
export const PlayyardForegroundGrass = () => {
  return (
    <Column className="pointer-events-none absolute inset-x-0 bottom-0 z-[35] h-[9%]">
      {BLADES.map((blade, index) => (
        <Column
          key={index}
          className="staffer-pet-yard-sway absolute bottom-0 [clip-path:polygon(0_100%,15%_35%,30%_100%,45%_0,60%_100%,75%_30%,90%_100%)]"
          style={{
            left: `${blade.left.toString()}%`,
            width: `${blade.widthCqw.toString()}cqw`,
            height: `${(blade.widthCqw * 0.9).toString()}cqw`,
            backgroundColor: "color-mix(in srgb, var(--yard-tuft) 75%, black)",
            animationDelay: `${blade.delayS.toString()}s`,
          }}
        />
      ))}
    </Column>
  );
};
